import TemplateView from '../../../../TemplateView'

export default class Counter extends TemplateView {
    constructor() {
        super()

        this.state = {
            text: '',
            withWarning: false,
        }

        this.onStatePropertyChanged('text', () => {
            this.$el.text(this.state.text)
        })

        this.onStatePropertyChanged('withWarning', () => {
            this.$el.toggleClass('withWarning', this.state.withWarning)
        })
    }

    templateHtml() {
        return '<div class="userManagement_licenseCounter">' +
               '</div>'
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/license/Counter.js